<div class="flex h-screen w-full items-center justify-center bg-gray-100">
  <div
    class="mx-auto w-full max-w-md rounded-lg bg-white p-8 text-center shadow-lg">
    <div class="flex flex-col items-center justify-center">
      <div class="mb-6">
        <img src="assets/img/payS_1.png" alt="PayS logo" class="h-12 w-auto" />
      </div>

      <h2 class="mb-2 text-2xl font-semibold text-gray-800">
        Payment Reference Not Found
      </h2>
      <p class="mb-6 text-base font-light text-gray-600">
        We couldn't find the payment reference you were looking for. Please
        check the reference number and try again.
      </p>
    </div>
  </div>
</div>
